/* デニム カスタムオーダーオプションのフォーム挙動
   - PAPER PATCH: Normal A / Normal B (Freetext) 選択時のみ刻印テキストを表示
   - TAB TEXT: プリセット選択 or その他選択時のテキスト入力切替と文字数制限 */

/* ── 共通ユーティリティ ──
   刻印テキストは [A-Za-z ] 以外を無言で削除していたため、日本語や数字を
   入力したお客様は「文字が出ない」まま空欄で注文でき、注文メールから
   刻印情報が丸ごと欠落していた。入力が弾かれた理由を必ず画面に出す。 */
var DenimCO = (function () {
  var i18nRoot = document.getElementById('denim-custom-order-options');
  var rootData = i18nRoot ? i18nRoot.dataset : {};
  var locale = rootData.locale || 'en-US';
  var currencyCode = rootData.currencyCode || 'USD';
  var cartAddUrl = rootData.cartAddUrl || '/cart/add.js';
  var cartChangeUrl = rootData.cartChangeUrl || '/cart/change.js';
  var i18n = {
    lines: rootData.i18nLines || 'Up to {max} lines',
    chars: rootData.i18nChars || 'Max {max} characters per line',
    lettersOnly: rootData.i18nLettersOnly || 'Letters and spaces only',
    patchRequired: rootData.i18nPatchRequired || 'Please enter the patch text',
    charUnit: rootData.i18nCharUnit || 'characters',
    addonFailed: rootData.i18nAddonFailed || "We couldn't add your selected options. Please try again.",
    rollbackFailed: rootData.i18nRollbackFailed || "We couldn't add your selected options. Please check your cart before trying again."
  };

  function interpolate(template, max) {
    return String(template).replace(/\{max\}/g, String(max));
  }

  function messageFor(raw, maxLines, maxLen, allowedRe, label) {
    if (allowedRe.test(raw)) return label;
    if (raw.split('\n').length > maxLines) {
      return interpolate(i18n.lines, maxLines);
    }
    return interpolate(i18n.chars, maxLen);
  }

  return {
    messages: i18n,
    locale: locale,
    currencyCode: currencyCode,
    cartAddUrl: cartAddUrl,
    cartChangeUrl: cartChangeUrl,
    /* エラー / 注意メッセージを表示。isError=false は数秒で自動的に消える */
    showMessage: function (el, msg, isError) {
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      el.classList.toggle('denim-co__field-error--hard', !!isError);
      if (el._denimTimer) clearTimeout(el._denimTimer);
      if (!isError) {
        el._denimTimer = setTimeout(function () {
          el.hidden = true;
          el.textContent = '';
        }, 6000);
      }
    },
    clearMessage: function (el) {
      if (!el) return;
      if (el._denimTimer) clearTimeout(el._denimTimer);
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('denim-co__field-error--hard');
    },
    /* 弾かれた理由の文言を組み立てる（刻印テキスト用） */
    stripReason: function (raw, maxLines, maxLen) {
      return messageFor(
        raw,
        maxLines,
        maxLen,
        /[^A-Za-z \n]/,
        i18n.lettersOnly
      );
    },
    /* エラー箇所までスクロールしてフォーカス */
    focusField: function (field, wrap) {
      var target = wrap && wrap.offsetParent !== null ? wrap : field;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (field) {
        try {
          field.focus({ preventScroll: true });
        } catch (e) {
          field.focus();
        }
      }
    }
  };
})();

(function () {
  /* ── PAPER PATCH: Normal A / Normal B 選択時のみ刻印テキスト入力を表示 ──
     NONE（無し）選択時は PATCH DETAIL（Lot / W / L 刻印）を非表示にし、
     入力値をクリアして空 property として送信（Shopify が注文表示から除外）。 */
  var patchRadios = document.querySelectorAll('input[name="properties[PAPER PATCH / 紙パッチ]"]');
  var patchTextWrap = document.getElementById('denim-co-patch-text-wrap');
  var patchText = document.getElementById('denim-co-patch-text');
  var patchCount = patchTextWrap ? patchTextWrap.querySelector('.denim-co__patch-text-count') : null;
  var patchDetail = document.querySelector('.denim-co__patch-detail');
  var patchDetailInputs = patchDetail ? patchDetail.querySelectorAll('.denim-co__patch-input') : [];

  function togglePatchDetail() {
    if (!patchDetail) return;
    var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
    var val = checked ? checked.value : '';
    var hide = val === 'NONE';
    patchDetail.style.display = hide ? 'none' : '';
    if (hide) {
      patchDetailInputs.forEach(function (input) { input.value = ''; });
    }
  }

  function sanitizePatchText(raw) {
    var lines = (raw || '').split('\n');
    if (lines.length > 2) lines = lines.slice(0, 2);
    return lines
      .map(function (line) {
        return line.replace(/[^A-Za-z ]/g, '').slice(0, 20);
      })
      .join('\n');
  }

  function updatePatchCount() {
    if (!patchText || !patchCount) return;
    var lines = (patchText.value || '').split('\n');
    var l1 = (lines[0] || '').length;
    var l2 = (lines[1] || '').length;
    patchCount.textContent = 'Line 1: ' + l1 + ' / 20　Line 2: ' + l2 + ' / 20';
  }

  var DEFAULT_PATCH_TEXT = 'NOSHIRO JEANS';

  function togglePatchText() {
    if (!patchTextWrap) return;
    var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
    var val = checked ? checked.value : '';
    var show = val === 'Normal A (Freetext)' || val === 'Normal B (Freetext)';
    patchTextWrap.style.display = show ? 'block' : 'none';
    if (!show && patchText) {
      patchText.value = '';
      DenimCO.clearMessage(patchError);
      updatePatchCount();
    } else if (show && patchText && !patchText.value) {
      patchText.value = DEFAULT_PATCH_TEXT;
      updatePatchCount();
    }
  }

  var patchError = document.querySelector('[data-patch-text-error]');

  if (patchText) {
    patchText.addEventListener('input', function () {
      var raw = this.value;
      var cleaned = sanitizePatchText(raw);
      if (raw !== cleaned) {
        this.value = cleaned;
        DenimCO.showMessage(patchError, DenimCO.stripReason(raw, 2, 20), false);
      } else if (cleaned.trim() !== '') {
        DenimCO.clearMessage(patchError);
      }
      updatePatchCount();
    });

    /* 空のままフォーカスを外したら警告（Freetext 選択時のみ） */
    patchText.addEventListener('blur', function () {
      var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
      var val = checked ? checked.value : '';
      var needed = val === 'Normal A (Freetext)' || val === 'Normal B (Freetext)';
      if (needed && this.value.trim() === '') {
        DenimCO.showMessage(
          patchError,
          DenimCO.messages.patchRequired,
          true
        );
      }
    });
  }

  patchRadios.forEach(function (r) {
    r.addEventListener('change', togglePatchText);
    r.addEventListener('change', togglePatchDetail);
  });
  togglePatchText();
  togglePatchDetail();
  updatePatchCount();
})();

(function () {
  /* TAB TEXT: プリセット/その他切替・6文字・縦書き・漢字不可 */
  var hiddenInput = document.getElementById('denim-co-tab-text-value');
  var customBlock = document.getElementById('denim-co-custom-block');
  var customWrap = document.getElementById('denim-co-custom-wrap');
  var textInput = document.getElementById('denim-co-tab-text');
  var presetRadios = document.querySelectorAll('input[name="tab-text-preset"]');
  if (!hiddenInput || !customBlock || !textInput) return;

  var counter = customWrap ? customWrap.querySelector('.denim-co__char-count') : null;
  var maxLen = parseInt(textInput.dataset.maxLen, 10) || 6;
  /* 許可: 半角英数字 / ひらがな / カタカナ(長音符含む)。漢字・その他文字は除去 */
  var disallowedRe = /[^A-Za-z0-9\u3041-\u3096\u30A1-\u30FA\u30FC]/g;

  function updateCounter() {
    var cleaned = textInput.value.replace(disallowedRe, '').slice(0, maxLen);
    if (cleaned !== textInput.value) textInput.value = cleaned;

    if (counter) {
      counter.textContent = cleaned.length + ' / ' + maxLen + ' ' + DenimCO.messages.charUnit;
      counter.dataset.over = 'false';
    }

    hiddenInput.value = cleaned;
  }

  presetRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.value === '') {
        /* その他 */
        customBlock.style.display = 'block';
        textInput.focus();
        updateCounter();
      } else {
        customBlock.style.display = 'none';
        hiddenInput.value = this.value;
      }
    });
  });

  /* TAB COLOR が「無し」の時は TAB TEXT を非表示にして送信しない */
  var tabTextGroup = document.getElementById('denim-co-tabtext-group');
  var colorRadios = document.querySelectorAll('input[name="properties[TAB COLOR / タブカラー]"]');

  function currentTabTextValue() {
    var checked = document.querySelector('input[name="tab-text-preset"]:checked');
    if (!checked) return '';
    return checked.value === '' ? textInput.value : checked.value;
  }

  function syncTabText() {
    var c = document.querySelector('input[name="properties[TAB COLOR / タブカラー]"]:checked');
    var isNone = c && c.value === 'NONE';
    if (tabTextGroup) tabTextGroup.style.display = isNone ? 'none' : '';
    hiddenInput.disabled = isNone;
    hiddenInput.value = isNone ? '' : currentTabTextValue();
  }

  colorRadios.forEach(function (radio) {
    radio.addEventListener('change', syncTabText);
  });
  syncTabText();

  textInput.addEventListener('input', updateCounter);
})();

(function () {
  /* ── Back Pocket Stencil: checkbox ON 時のみ textarea を表示 ──
     許可文字: 大文字 A-Z, 数字 0-9, 記号 ! ? ' - # & @ % : / ; と改行。
     lowercase 入力は自動 uppercase 変換、その他文字はストリップ。
     unchecked 時は value を空にクリア。 */
  var stencilCheck = document.querySelector('.denim-co__addon-check[name="properties[Back Pocket Stencil / バックポケット・ステンシル]"]');
  var panel = document.getElementById('denim-co-stencil-wrap');
  if (!stencilCheck || !panel) return;

  var stencilText = document.getElementById('denim-co-stencil-text');
  var stencilRe = /[^A-Z0-9!?'\-#&@%:/;\n]/g;

  function sanitizeStencilText(raw) {
    return (raw || '').toUpperCase().replace(stencilRe, '');
  }

  function toggleStencilPanel() {
    var on = stencilCheck.checked;
    panel.style.display = on ? 'block' : 'none';
    if (!on && stencilText) stencilText.value = '';
  }

  if (stencilText) {
    stencilText.addEventListener('input', function () {
      var cleaned = sanitizeStencilText(this.value);
      if (this.value !== cleaned) this.value = cleaned;
    });
  }

  stencilCheck.addEventListener('change', toggleStencilPanel);
  toggleStencilPanel();
})();

(function () {
  /* ── Leather Patch: checkbox ON 時のみ詳細パネル (Type A/B + Text + Lot/W/L) を表示 ──
     unchecked 時はパネル非表示 + 全フィールドをクリアして空 property として送信。 */
  var leatherCheck = document.querySelector('.denim-co__addon-check[name="properties[Leather Patch / 皮パッチ]"]');
  var panel = document.getElementById('denim-co-leather-wrap');
  if (!panel) return;

  var typeRadios = panel.querySelectorAll('.denim-co__leather-type');
  var leatherText = document.getElementById('denim-co-leather-text');
  var leatherCount = panel.querySelector('[data-leather-count]');
  var leatherFields = panel.querySelectorAll('.denim-co__leather-field');
  var leatherError = panel.querySelector('[data-leather-text-error]');

  /* 皮パッチ商品が売り切れ / 非公開でチェックボックスが描画されない場合、
     Type A(checked) と textarea 初期値 "NOSHIRO JEANS" がそのまま送信されて
     しまうため、ここで必ずクリアしてから抜ける。 */
  if (!leatherCheck) {
    typeRadios.forEach(function (r) { r.checked = false; });
    if (leatherText) leatherText.value = '';
    leatherFields.forEach(function (f) { f.value = ''; });
    panel.style.display = 'none';
    return;
  }

  function sanitizeLeatherText(raw) {
    var lines = (raw || '').split('\n');
    if (lines.length > 2) lines = lines.slice(0, 2);
    return lines
      .map(function (line) { return line.replace(/[^A-Za-z ]/g, '').slice(0, 20); })
      .join('\n');
  }

  function updateLeatherCount() {
    if (!leatherText || !leatherCount) return;
    var lines = (leatherText.value || '').split('\n');
    var l1 = (lines[0] || '').length;
    var l2 = (lines[1] || '').length;
    leatherCount.textContent = 'Line 1: ' + l1 + ' / 20　Line 2: ' + l2 + ' / 20';
  }

  function clearLeatherFields() {
    typeRadios.forEach(function (r) { r.checked = false; });
    if (leatherText) leatherText.value = '';
    leatherFields.forEach(function (f) { f.value = ''; });
    DenimCO.clearMessage(leatherError);
    updateLeatherCount();
  }

  var DEFAULT_LEATHER_TEXT = 'NOSHIRO JEANS';

  function toggleLeatherPanel() {
    var on = leatherCheck.checked;
    panel.style.display = on ? 'block' : 'none';
    if (on) {
      var anyChecked = false;
      typeRadios.forEach(function (r) { if (r.checked) anyChecked = true; });
      if (!anyChecked && typeRadios.length) typeRadios[0].checked = true;
      if (leatherText && !leatherText.value) {
        leatherText.value = DEFAULT_LEATHER_TEXT;
        updateLeatherCount();
      }
    } else {
      clearLeatherFields();
    }
  }

  if (leatherText) {
    leatherText.addEventListener('input', function () {
      var raw = this.value;
      var cleaned = sanitizeLeatherText(raw);
      if (raw !== cleaned) {
        this.value = cleaned;
        DenimCO.showMessage(leatherError, DenimCO.stripReason(raw, 2, 20), false);
      } else if (cleaned.trim() !== '') {
        DenimCO.clearMessage(leatherError);
      }
      updateLeatherCount();
    });

    leatherText.addEventListener('blur', function () {
      if (leatherCheck.checked && this.value.trim() === '') {
        DenimCO.showMessage(
          leatherError,
          DenimCO.messages.patchRequired,
          true
        );
      }
    });
  }

  /* ── 皮パッチにチェックした瞬間に紙パッチを NONE に固定する ──
     以前は submit 時にだけ NONE へ倒していたため、Apple Pay / Shop Pay など
     フォームの submit を経由しない決済だと紙パッチのデザインが残ったまま
     注文されてしまった（注文 #1008）。選択した時点で確定させる。
     チェックを外したら元の選択に戻す。 */
  var paperRadios = document.querySelectorAll('input[name="properties[PAPER PATCH / 紙パッチ]"]');
  var paperGrid = document.querySelector('[data-paper-grid]');
  var paperNote = document.querySelector('[data-paper-locked-note]');
  var paperNone = document.getElementById('patch-none');
  var previousPaper = '';

  function currentPaper() {
    var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
    return checked ? checked.value : '';
  }

  function forcePaperNone() {
    if (!paperNone || paperNone.checked) return;
    paperNone.checked = true;
    /* 既存の change ハンドラ（刻印テキスト / Lot・W・L のクリア）を走らせる */
    paperNone.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function togglePaperLock() {
    var locked = leatherCheck.checked;

    if (locked) {
      var now = currentPaper();
      if (now && now !== 'NONE') previousPaper = now;
      forcePaperNone();
    } else if (previousPaper) {
      var restore = null;
      paperRadios.forEach(function (r) { if (r.value === previousPaper) restore = r; });
      previousPaper = '';
      if (restore && !restore.checked) {
        restore.checked = true;
        restore.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (paperGrid) {
      paperGrid.classList.toggle('denim-co__grid--locked', locked);
      paperGrid.setAttribute('aria-disabled', locked ? 'true' : 'false');
    }
    if (paperNote) paperNote.hidden = !locked;
  }

  /* キーボード操作などでロックをすり抜けた場合も NONE に戻す */
  paperRadios.forEach(function (r) {
    r.addEventListener('change', function () {
      if (leatherCheck.checked && this.value !== 'NONE') {
        previousPaper = this.value;
        forcePaperNone();
        if (paperNote) paperNote.hidden = false;
      }
    });
  });

  leatherCheck.addEventListener('change', toggleLeatherPanel);
  leatherCheck.addEventListener('change', togglePaperLock);
  toggleLeatherPanel();
  togglePaperLock();
  updateLeatherCount();
})();

(function () {
  /* ── Add-on Options: 合計金額のリアルタイム表示 + add to cart 成功後の自動投入 ── */
  var addonChecks = document.querySelectorAll('.denim-co__addon-check');
  var totalEl = document.querySelector('[data-addon-total]');
  if (!addonChecks.length || !totalEl) return;

  function formatAddonTotal(n) {
    var formatted;
    try {
      formatted = new Intl.NumberFormat(DenimCO.locale, {
        style: 'currency',
        currency: DenimCO.currencyCode
      }).format(n);
    } catch (e) {
      formatted = n.toLocaleString(DenimCO.locale);
    }
    return '+ ' + formatted;
  }

  function updateAddonTotal() {
    var sum = 0;
    addonChecks.forEach(function (c) {
      if (c.checked) {
        var p = parseFloat(c.dataset.addonPrice);
        if (!isNaN(p)) sum += p;
      }
    });
    totalEl.textContent = formatAddonTotal(sum);
    totalEl.dataset.amount = sum;
  }

  addonChecks.forEach(function (c) {
    c.addEventListener('change', updateAddonTotal);
  });
  updateAddonTotal();

  /* ── add to cart 成功時に選択された add-on を /cart/add.js で自動投入 ──
     PUB_SUB cartUpdate (source='product-form') を待ち受け、メイン商品の key を
     拾って _main_line_item_key property を付けて add-on を追加。
     cart-drawer を改めて再描画して追加された add-on を表示。 */
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (!data || data.source !== 'product-form') return;

    var boundFormId = i18nRoot ? i18nRoot.dataset.productFormId : '';
    var boundForm = boundFormId ? document.getElementById(boundFormId) : null;
    var boundVariantInput = boundForm ? boundForm.querySelector('[name="id"]') : null;
    if (boundVariantInput && parseInt(boundVariantInput.value, 10) !== parseInt(data.productVariantId, 10)) return;

    var checked = [];
    addonChecks.forEach(function (c) { if (c.checked && c.dataset.variantId) checked.push(c); });
    if (!checked.length) return;

    var mainVariantId = parseInt(data.productVariantId, 10);
    var mainItem = null;
    if (data.cartData && data.cartData.key && data.cartData.variant_id === mainVariantId) {
      mainItem = data.cartData;
    } else if (data.cartData && Array.isArray(data.cartData.items)) {
      for (var i = data.cartData.items.length - 1; i >= 0; i--) {
        if (data.cartData.items[i].variant_id === mainVariantId) {
          mainItem = data.cartData.items[i];
          break;
        }
      }
    }
    var mainKey = mainItem ? mainItem.key : '';
    var addonError = document.querySelector('[data-addon-error]');
    var submitButton = boundForm ? boundForm.querySelector('[type="submit"]') : null;
    var quantityInput = boundForm ? boundForm.querySelector('[name="quantity"]') : null;
    var addedQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!mainKey) {
      DenimCO.showMessage(addonError, DenimCO.messages.addonFailed, true);
      return Promise.reject(new Error(DenimCO.messages.addonFailed));
    }

    var items = checked.map(function (c) {
      return {
        id: parseInt(c.dataset.variantId, 10),
        quantity: 1,
        properties: {
          '_main_line_item_key': mainKey,
          '_addon_for': mainItem ? mainItem.product_title : ''
        }
      };
    });

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = [];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    }

    if (submitButton) submitButton.disabled = true;

    return fetch(DenimCO.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || (json && json.status)) {
            throw new Error((json && (json.description || json.message)) || DenimCO.messages.addonFailed);
          }
          return json;
        });
      })
      .then(function (json) {
        if (cart && json && json.sections && typeof cart.renderContents === 'function') {
          /* Multi-item /cart/add responses expose `items`, while Dawn cart UI
             expects a single line item's key/id plus the refreshed sections. */
          try {
            cart.renderContents({
              id: mainItem.id || mainItem.variant_id,
              key: mainKey,
              sections: json.sections
            });
          } catch (renderError) {
            /* The cart contents are already correct. A UI refresh failure must
               never trigger a data rollback that would orphan the add-ons. */
            console.error('[denim-addon] add-ons added, but cart UI refresh failed:', renderError);
          }
        }
      }, function (err) {
        console.error('[denim-addon] failed to add add-on items:', err);
        return fetch(DenimCO.cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: mainKey,
            quantity: Math.max((parseInt(mainItem.quantity, 10) || addedQuantity) - addedQuantity, 0),
            sections: sections,
            sections_url: window.location.pathname
          })
        })
          .then(function (res) {
            return res.json().then(function (rollbackState) {
              if (!res.ok || (rollbackState && rollbackState.status)) {
                throw new Error((rollbackState && (rollbackState.description || rollbackState.message)) || DenimCO.messages.rollbackFailed);
              }
              return rollbackState;
            });
          })
          .then(function (rollbackState) {
            if (cart && rollbackState && rollbackState.sections) {
              if (cart.tagName === 'CART-NOTIFICATION') {
                cart.getSectionsToRender().forEach(function (section) {
                  var host = document.getElementById(section.id);
                  var html = rollbackState.sections[section.id];
                  if (!host || !html) return;
                  var parsed = new DOMParser().parseFromString(html, 'text/html');
                  var replacement = parsed.querySelector(section.selector || '.shopify-section');
                  if (replacement) host.innerHTML = replacement.innerHTML;
                });
                if (typeof cart.close === 'function') cart.close();
              } else if (typeof cart.renderContents === 'function') {
                cart.renderContents({ id: mainItem.id || mainItem.variant_id, sections: rollbackState.sections });
              }
            }
            DenimCO.showMessage(addonError, DenimCO.messages.addonFailed, true);
            return { rolledBack: true };
          })
          .catch(function (rollbackError) {
            console.error('[denim-addon] failed to roll back main item:', rollbackError);
            DenimCO.showMessage(addonError, DenimCO.messages.rollbackFailed, true);
            return { rolledBack: false };
          })
          .then(function (result) {
            if (!cart) {
              throw new Error(result.rolledBack ? DenimCO.messages.addonFailed : DenimCO.messages.rollbackFailed);
            }
          });
      })
      .finally(function () {
        if (submitButton) submitButton.disabled = false;
      });
  });
})();

(function () {
  /* ── このジーンズに紐付くオプションのサマリー更新 ──
     可視 <p data-addon-summary-display> と隠し <input data-addon-summary-input>
     を同期。Leather Patch チェック時は Type A/B も併記。
     何も選ばれていない時は表示要素を非表示にし、hidden input は空文字に保つ
     (Shopify は空 property を注文表示から除外する)。 */
  var addonChecks = document.querySelectorAll('.denim-co__addon-check');
  var display = document.querySelector('[data-addon-summary-display]');
  var valueEl = document.querySelector('[data-addon-summary-value]');
  var hiddenInput = document.querySelector('[data-addon-summary-input]');
  if (!addonChecks.length || !display || !valueEl || !hiddenInput) return;

  function rebuildSummary() {
    var labels = [];
    addonChecks.forEach(function (c) {
      if (!c.checked) return;
      var label = (c.name.match(/properties\[(.+)\]/) || [])[1] || '';
      if (!label) return;
      /* name は "Leather Patch / 皮パッチ" 形式なので前方一致で判定する */
      if (label.indexOf('Leather Patch') === 0) {
        var typeRadio = document.querySelector('input[name="properties[Leather Patch Type / 皮パッチタイプ]"]:checked');
        if (typeRadio && typeRadio.value) label += ' (' + typeRadio.value + ')';
      }
      labels.push(label);
    });
    var summary = labels.join(' / ');
    hiddenInput.value = summary;
    if (summary) {
      valueEl.textContent = summary;
      display.hidden = false;
    } else {
      valueEl.textContent = '';
      display.hidden = true;
    }
  }

  addonChecks.forEach(function (c) { c.addEventListener('change', rebuildSummary); });
  /* Leather Type radio の change にも反応 */
  document.querySelectorAll('input[name="properties[Leather Patch Type / 皮パッチタイプ]"]').forEach(function (r) {
    r.addEventListener('change', rebuildSummary);
  });
  rebuildSummary();
})();

(function () {
  /* ── 画像 lightbox: .denim-co__zoomable をクリックで overlay 拡大表示 ──
     対象: pdesc-options 内の addon01/02、TAB TEXT の tab-sample 等。
     overlay クリック / × ボタン / Esc キーで閉じる。
     祖先要素に transform/filter/will-change が付いていると
     position:fixed が viewport ではなくその祖先基準になってしまうので、
     init 時に body 直下へ移動して影響を断ち切る。 */
  var lightbox = document.querySelector('[data-denim-lightbox]');
  if (!lightbox) return;
  if (lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }
  var img = lightbox.querySelector('.denim-co__lightbox-img');
  var closeBtn = lightbox.querySelector('.denim-co__lightbox-close');
  var activeTrigger = null;

  document.querySelectorAll('.denim-co__zoomable').forEach(function (zoomable) {
    zoomable.setAttribute('tabindex', '0');
    zoomable.setAttribute('role', 'button');
    zoomable.setAttribute('aria-haspopup', 'dialog');
  });

  function open(src, alt, trigger) {
    activeTrigger = trigger || document.activeElement;
    img.src = src;
    img.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    lightbox.hidden = true;
    img.src = '';
    document.body.style.overflow = '';
    if (activeTrigger && typeof activeTrigger.focus === 'function') activeTrigger.focus();
    activeTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (target && target.classList && target.classList.contains('denim-co__zoomable') && target.tagName === 'IMG') {
      e.preventDefault();
      open(target.currentSrc || target.src, target.alt, target);
    }
  });

  document.addEventListener('keydown', function (e) {
    var target = e.target;
    if (
      target &&
      target.classList &&
      target.classList.contains('denim-co__zoomable') &&
      (e.key === 'Enter' || e.key === ' ')
    ) {
      e.preventDefault();
      open(target.currentSrc || target.src, target.alt, target);
    }
  });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox || e.target === closeBtn) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lightbox.hidden) close();
    if (e.key === 'Tab' && !lightbox.hidden) {
      e.preventDefault();
      closeBtn.focus();
    }
  });
})();

(function () {
  /* 皮パッチ(Leather Patch アドオン)を選択した状態でカートに入れたら、
     紙パッチ(PAPER PATCH)を自動で NONE にする。カート投入のタイミングで確定。
     既存の PAPER PATCH change ハンドラを発火させ、Patch Text / Lot・W・L も併せてクリア。 */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      var leather = document.querySelector('input[name="properties[Leather Patch / 皮パッチ]"]');
      if (!leather || !leather.checked) return;

      /* この submit が皮/紙パッチの属する商品フォームかを form 属性で照合 */
      var boundFormId = leather.getAttribute('form');
      if (boundFormId && boundFormId !== form.id) return;

      var paperNone = document.getElementById('patch-none');
      if (paperNone && !paperNone.checked) {
        paperNone.checked = true;
        paperNone.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    true /* capture: Dawn の product-form submit ハンドラより先に走らせる */
  );
})();

(function () {
  /* ── Lot / W / L の既定値補完 + 刻印テキストの必須チェック ──
     画面の案内文（未入力なら Lot=001 / W=選択サイズ / L=32 が入る）に対して
     実装が無く、未入力のまま注文されると空プロパティになって Shopify 側で
     捨てられ、注文メールから刻印情報が丸ごと消えていた。
     - 値は常に埋めておく（Shop Pay / Apple Pay 等 form submit を経由しない
       決済経路でも欠落しないように）
     - submit 時にも最終補完 + 刻印テキストの空チェックを行う */
  var root = document.getElementById('denim-custom-order-options');
  if (!root) return;

  var formId = root.dataset.productFormId || '';
  var sizeIndex = parseInt(root.dataset.sizeOptionIndex, 10);
  if (isNaN(sizeIndex)) sizeIndex = 0;
  var DEFAULT_LOT = root.dataset.defaultLot || '001';
  var DEFAULT_L = root.dataset.defaultL || '32';

  function byName(name) {
    return root.querySelector('input[name="properties[' + name + ']"]');
  }
  var paper = {
    lot: byName('Patch Lot / 紙パッチLot'),
    w: byName('Patch W / 紙パッチW'),
    l: byName('Patch L / 紙パッチL')
  };
  var leather = {
    lot: byName('Leather Patch Lot / 皮パッチLot'),
    w: byName('Leather Patch W / 皮パッチW'),
    l: byName('Leather Patch L / 皮パッチL')
  };

  var lastVariant = null;

  function selectedSize() {
    var v = lastVariant;
    if (!v) {
      var node = document.querySelector('variant-selects [data-selected-variant]');
      if (node) {
        try {
          v = JSON.parse(node.textContent);
        } catch (e) {
          v = null;
        }
      }
    }
    var raw = '';
    if (v) {
      if (v.options && v.options.length) {
        raw = v.options[Math.min(sizeIndex, v.options.length - 1)] || '';
      } else {
        raw = v.option1 || '';
      }
    }
    raw = String(raw || '');
    var m = raw.match(/\d{2}/) || raw.match(/\d/);
    if (m) return m[0];
    return raw.replace(/[^A-Za-z0-9/-]/g, '').slice(0, 2);
  }

  function isPaperActive() {
    var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
    return !!checked && checked.value !== 'NONE';
  }

  function isLeatherActive() {
    var c = document.querySelector('.denim-co__addon-check[name="properties[Leather Patch / 皮パッチ]"]');
    return !!c && c.checked;
  }

  /* force=true: 未入力なら touched でも必ず既定値を入れる（submit 直前用） */
  function applyDefaults(fields, active, force) {
    if (!active) return;
    if (fields.lot && fields.lot.value.trim() === '' && (force || fields.lot.dataset.touched !== '1')) {
      fields.lot.value = DEFAULT_LOT;
      fields.lot.dataset.auto = '1';
    }
    if (fields.l && fields.l.value.trim() === '' && (force || fields.l.dataset.touched !== '1')) {
      fields.l.value = DEFAULT_L;
      fields.l.dataset.auto = '1';
    }
    if (fields.w) {
      var size = selectedSize();
      var replaceable = fields.w.value.trim() === '' || (fields.w.dataset.auto === '1' && fields.w.dataset.touched !== '1');
      if (size && replaceable) {
        fields.w.value = size;
        fields.w.dataset.auto = '1';
      }
    }
  }

  function sync(force) {
    applyDefaults(paper, isPaperActive(), force);
    applyDefaults(leather, isLeatherActive(), force);
  }

  /* ── 刻印テキスト未入力時は Shop Pay / Apple Pay 等の即時決済を止める ──
     これらは form の submit を経由しないため下の必須チェックが働かず、
     刻印テキストが空のまま注文が確定してしまう。 */
  function requiredTextMissing() {
    var patchText = document.getElementById('denim-co-patch-text');
    var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
    var pv = checked ? checked.value : '';
    if (
      (pv === 'Normal A (Freetext)' || pv === 'Normal B (Freetext)') &&
      patchText &&
      patchText.value.trim() === ''
    ) {
      return true;
    }
    var leatherText = document.getElementById('denim-co-leather-text');
    return !!(isLeatherActive() && leatherText && leatherText.value.trim() === '');
  }

  function updateAcceleratedState() {
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;
    var blocked = requiredTextMissing();
    form
      .querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
      .forEach(function (el) {
        el.classList.toggle('denim-co__pay-blocked', blocked);
      });
  }

  ['denim-co-patch-text', 'denim-co-leather-text'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', updateAcceleratedState);
  });

  [paper, leather].forEach(function (set) {
    ['lot', 'w', 'l'].forEach(function (k) {
      var f = set[k];
      if (!f) return;
      f.addEventListener('input', function () {
        this.dataset.touched = '1';
        delete this.dataset.auto;
      });
    });
  });

  document.querySelectorAll('input[name="properties[PAPER PATCH / 紙パッチ]"]').forEach(function (r) {
    r.addEventListener('change', function () {
      sync(false);
      updateAcceleratedState();
    });
  });
  var leatherCheckbox = document.querySelector('.denim-co__addon-check[name="properties[Leather Patch / 皮パッチ]"]');
  if (leatherCheckbox) {
    leatherCheckbox.addEventListener('change', function () {
      sync(false);
      updateAcceleratedState();
    });
  }

  /* バリアント（サイズ）変更に追従して W を更新 */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (data) {
      if (data && data.data && data.data.variant) lastVariant = data.data.variant;
      sync(false);
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      lastVariant = null;
      setTimeout(function () { sync(false); }, 400);
    }
  });

  sync(false);
  updateAcceleratedState();
  /* 即時決済ボタンは遅れて描画されることがあるため再適用 */
  setTimeout(updateAcceleratedState, 1500);

  /* ── submit 直前の最終補完 + 刻印テキスト必須チェック ── */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (formId) {
        if (form.id !== formId) return;
      } else if (!form.querySelector('[name="id"]')) {
        return;
      }

      /* 皮パッチ選択時に紙パッチを NONE に倒す処理が先に走った後の状態で判定する */
      sync(true);

      var problem = null;
      var patchText = document.getElementById('denim-co-patch-text');
      var checked = document.querySelector('input[name="properties[PAPER PATCH / 紙パッチ]"]:checked');
      var pv = checked ? checked.value : '';

      if (
        (pv === 'Normal A (Freetext)' || pv === 'Normal B (Freetext)') &&
        patchText &&
        patchText.value.trim() === ''
      ) {
        problem = {
          field: patchText,
          wrap: document.getElementById('denim-co-patch-text-wrap'),
          error: document.querySelector('[data-patch-text-error]')
        };
      }

      var leatherText = document.getElementById('denim-co-leather-text');
      if (!problem && isLeatherActive() && leatherText && leatherText.value.trim() === '') {
        problem = {
          field: leatherText,
          wrap: document.getElementById('denim-co-leather-wrap'),
          error: document.querySelector('[data-leather-text-error]')
        };
      }

      if (!problem) {
        /* 空白のみ / 行末スペースは Liquid の blank 判定で消えるため掃除する */
        [patchText, leatherText].forEach(function (t) {
          if (!t || !t.value) return;
          t.value = t.value
            .split('\n')
            .map(function (line) { return line.replace(/\s+$/, ''); })
            .join('\n')
            .replace(/^\n+/, '');
        });
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      DenimCO.showMessage(
        problem.error,
        DenimCO.messages.patchRequired,
        true
      );
      DenimCO.focusField(problem.field, problem.wrap);
    },
    true /* capture: Dawn の product-form submit ハンドラより先に走らせる */
  );
})();
